import React, { useState, useEffect } from 'react';
import { ThemeProvider, Box, Text } from '@primer/react';
import './App.css';
import Head from './components/Head';
import { I18nextProvider, useTranslation } from 'react-i18next';
import i18n from './i18n';
import { FluentProvider, webLightTheme, webDarkTheme } from '@fluentui/react-components';
import SearchItem from './components/SearchItem';
import DisplayItem from './components/DisplayItem';
import Footer from './components/Footer';

const App = () => {
  const { t } = useTranslation();
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [searchResult, setSearchResult] = useState(null);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  useEffect(() => {
    const body = document.body;
    if (isDarkMode) {
      body.classList.add('dark-mode');
      body.classList.remove('light-mode');
    } else {
      body.classList.add('light-mode');
      body.classList.remove('dark-mode');
    }
  }, [isDarkMode]);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e: MediaQueryListEvent) => {
      setIsDarkMode(e.matches);
    };

    handleChange({ matches: mediaQuery.matches } as MediaQueryListEvent); // Set initial theme
    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <FluentProvider theme={isDarkMode ? webDarkTheme : webLightTheme}>
        <div>
          <div className="header">
            <Head toggleTheme={toggleTheme} isDarkMode={isDarkMode} />
          </div>
          <div className="main">
            <Box sx={{ p: 3 }}>
              <SearchItem setSearchResult={setSearchResult} />
            </Box>
            <Box sx={{ p: 3 }}>
              <DisplayItem result={searchResult} />
            </Box>
          </div>
          <div className="footer">
            <Footer />
          </div>
        </div>
      </FluentProvider>
    </I18nextProvider>
  );
};

export default App;
